import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";
import { Box, Image } from "@chakra-ui/react";



export default function Carousel() {
  return (
    <Box  w="100%"  p="0px 15px" zIndex={-4000}  >
      <Swiper
      style={{
        "--swiper-pagination-color": "black",
      }}
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination]}
        className="mySwiper"
      >
        <SwiperSlide>
          <Image
            alt="1"
            src="https://static.thcdn.com/images/xlarge/webp/widgets/121-us/51/1180x450-070151.jpg"
            width={"100%"}
            height={"auto"}
          />
        </SwiperSlide>
        <SwiperSlide>
          <Image
            alt="2"
            src="https://static.thcdn.com/images/xlarge/webp/widgets/121-us/17/0905-STDCRE-40981-SS-EF-Sept-Batch-Priority-Shot09-1180x450-065417.jpg"
            width={"100%"}
            height={"auto"}
          />
        </SwiperSlide>
        
      </Swiper>
    </Box>
  );
}